import { FicheBar } from '@mairistem/fiche';
import _ from 'lodash';
import React from 'react';
import { ENV_DEV, ENV_LOCAL } from '@/constants';
import type { PayeurType } from '@/types';
import { useParametreStore, useRegieStore } from '@/zustand';

interface PayeurFicheBarProps {
  identifiant?: number | string;
  payeur?: PayeurType;
  mode?: 'edit' | 'read';
  onChange?: (data: any) => void;
  onCanceled?: (...args: any) => void;
  onSaved?: (...args: any) => void;
}

const PayeurFicheBar = (props: PayeurFicheBarProps) => {
  const { identifiant, payeur, onChange, ...handlers } = props;

  const suppressionPayeur = useParametreStore((states) => states.suppressionPayeur);
  const regieAutonome = useRegieStore((state) => state.regie?.autonome);

  const { logicielFacturier } = payeur || {};

  const handleCreate = React.useCallback(
    (data) => ({
      ...data,
      civilite: { identifiant: null },
      paysNaissance: 'France',
    }),
    [],
  );

  const handleSaving = React.useCallback(
    (data) => ({
      ..._.omit(data, 'nouveauCommentaire'),
      ...(!_.isEmpty(data.nouveauCommentaire) && {
        commentaire: `${`${data.nouveauCommentaire}\n`}${data.commentaire || ''}`,
      }),
    }),
    [],
  );

  return (
    <FicheBar
      key="PayeurFicheBar"
      type="payeur"
      identifiant={identifiant}
      canDraft={false}
      canCreate={ENV_LOCAL || ENV_DEV || regieAutonome}
      canDelete={_.isNil(logicielFacturier) || suppressionPayeur}
      {...handlers}
      onCreating={handleCreate}
      onSaving={handleSaving}
    />
  );
};

export default PayeurFicheBar;
